/**
 * 응답 소요 시간을 한국어 사용자에게 보여줄 문자열로 변환.
 *  - 1 초 미만 → "1초 미만"
 *  - 1 분 미만 → "5초" (정수)
 *  - 그 이상  → "2분 13초"
 */
export function formatElapsed(ms: number): string {
  if (!Number.isFinite(ms) || ms < 0) return '';
  if (ms < 1000) return '1초 미만';
  const totalSec = Math.floor(ms / 1000);
  if (totalSec < 60) return `${totalSec}초`;
  const m = Math.floor(totalSec / 60);
  const s = totalSec % 60;
  return s === 0 ? `${m}분` : `${m}분 ${s}초`;
}
